<div
  class="atlas-navbar__menu__item atlas-navbar__transition"
  (click)="clicked()"
  [class.atlas-navbar__menu__item--disabled]="disabled"
  >
  <!-- TODO: remove adding a target property based on the url. -->
  @if (!!url) {
    <a
      [href]="url"
      target="{{ isConquerLocalLink(url) ? '_blank' : '' }}"
      [attr.rel]="isConquerLocalLink(url) ? 'noopener' : null"
      >
      @if (!!icon) {
        <i class="material-icons">{{ icon }}</i>
      }
      {{ label }}
    </a>
  }
  @if (!!route) {
    <a [routerLink]="route">
      @if (!!icon) {
        <i class="material-icons">{{ icon }}</i>
      }
      {{ label }}
    </a>
  }
  @if (!url && !route && !!label) {
    <span>
      @if (!!icon) {
        <i class="material-icons">{{ icon }}</i>
      }
      {{ label }}
    </span>
  }
  <ng-content></ng-content>
</div>
